import { Avatar, Box, IconButton, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setToken } from "../../Reducers/Slices/LoginSlice";
import { LogoutAuthenticacion } from "../../Services/Comisiones/Authenticacion";
import { AxiosError } from "axios";
import { StatusCode } from "../../Services/StatusCode";
import { enqueueSnackbar } from "notistack";

interface OptionProps {
    perfil: string
}

const Option = ({ perfil }: OptionProps) => {
    const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
    const nagivate = useNavigate();

    const dispatch = useDispatch();
    const updateToken = (token: boolean) => {
        dispatch(
            setToken({
                token: token
            })
        )
    }
    const onCerrarSession = () => {
        logout();
    };

    const logout = async () => {
        try {
            const { data } = await LogoutAuthenticacion();
            updateToken(false);
            nagivate("/login");
        } catch (error) {
            const { message, status } = StatusCode(error);
            enqueueSnackbar(message, { variant: 'error' });
            updateToken(false);
            nagivate("/login");
        }
    }

    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        //nagivate("/perfil");
        setAnchorElUser(null);
    };

    const onVerPerfil = () => {
        nagivate("/perfil");
    };

    return (
        <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    <Avatar alt="Remy Sharp" src={`${process.env.REACT_APP_API_COMISIONES}${perfil}`} />
                </IconButton>
            </Tooltip>
            <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
            >
                <MenuItem onClick={onVerPerfil}>
                    <Typography textAlign="center">Perfil</Typography>
                </MenuItem>
                <MenuItem onClick={onCerrarSession}>
                    <Typography textAlign="center">Cerrar session</Typography>
                </MenuItem>
            </Menu>
        </Box>
    );
}

export default Option;